import React, { Component } from "react";
import { compose } from "redux";
import "bootstrap/dist/css/bootstrap.min.css";
import { withRouter } from "react-router-dom";
import { LoadingState } from "../../helpers/enum";
import '../../Shared/Style/textFormat.css';
import { isMobile } from '../../helpers/utils';
import BackButton from '../../Shared/BackButton';
import { Header, Category, LinkButton, LoadingMask } from '../../Shared';
import '../../Shared/Style/header.css';

class BankingAlertsPage extends Component {
    constructor(props) {
        super(props);
        this.pageName = props.match.params.name;
        // if (props.match.params.name.toLowerCase() === "security") {
        //   this.headerInfo = {
        //     subHeading: "Set Up Security Alerts",
        //     mainHeading: "Security Alerts",
        //     subHeadingDesc: "These notifications may include updates to your Online Banking settings, Notification Center settings, and other important issues."
        //   }
        // } else {
        //   this.headerInfo = {
        //     subHeading: "Set Up Regions LockIt Alerts",
        //     mainHeading: "Regions LockIt Alerts",
        //     subHeadingDesc: "These notifications may include updates regarding any Regions LockIt activity, such as blocked transactions and other important issues.",
        //   }
        // }

    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentDidUpdate() {
        setTimeout(() => {
            var root = document.getElementById("root");

            var _event = {};

            _event = {
                name: 'END_SETTING_HEIGHT',
                height: root.parentElement.parentElement.offsetHeight
            };

            //Post END Height Event for OLB 
            window.parent.postMessage(_event, '*')
        },
            0)
    };

    componentWillMount() {
        if (this.props.bankingAlertsState !== LoadingState.FULFILLED) {
            this.props.bankingAlerts();
            this.props.accountAlerts();
        }

        if (this.props.contactPreferenceState !== LoadingState.FULFILLED) {
            this.props.getContactPreferences(this.props.match.params.name);
        }

        this.props.getDeliveryChannels();      
    }
    render() {
        const { bankingAlertItem } = this.props;
        if (!bankingAlertItem) {
            return null;
        }
        else {
            this.headerInfo = {
                subHeading: bankingAlertItem.subtitle,
                mainHeading: bankingAlertItem.title,
                subHeadingDesc: bankingAlertItem.description
            };
            this.pageName = bankingAlertItem.name;
        }
        const contents = [];
        const contentType = [];

        bankingAlertItem.deliveryChannels.forEach(item => {

            var items = this.props.deliveryAddresses.filter(s => s.channel === item);
            if (item === "Push") {
                items = items.filter(s => s.nickname)
                items.forEach((it) => {
                    it.address = it.nickname;
                })
            } else if (item === "SMS") {
                items.forEach((item) => (
                    item.address = item.countryCode +
                    '-' + item.areaCode +
                    '-' + item.phoneNumber.substring(0, 3) +
                    '-' + item.phoneNumber.substring(3, 7)
                ));

            }
            const deliveryChannel = this.props.deliveryChannels.find(s => s.name === item) || {}
            contentType.push(deliveryChannel.description);
            contents.push(items)
        })

        if (this.props.bankingAlertsState === LoadingState.FULFILLED && this.props.contactPreferenceState === LoadingState.FULFILLED) {
            return (
                <>
                    {this.props.bankingAlertsState === LoadingState.PENDING &&
                        <LoadingMask ctrlCss={`fullpage`}
                            NavigationLink={this.pageName + `Alert`} />
                    }
                    <div aria-live="polite">
                        {this.props.bankingEnableAlertState === LoadingState.PENDING && <LoadingMask ctrlCss={`overlay`} />}
                    </div>
                    <div className={isMobile() ? `mobilecontainer-box` : `container-box`} >
                        <BackButton
                            href="#/landingPage"
                            text="Alerts"
                        />
                        <Header
                            {...this.headerInfo}

                        />
                        {!isMobile() ?
                        <div className="comp-header comp-header-subHeader-desc-prescription italic" role="text">
                            <p id="DescriptionText2">If you do not see your email or phone number listed, please visit {" "}
                                <a aria-label="Add/Edit Delivery Methods" className="AppLink desktop bold underline" href="#/alertPreferences/addOrEditMethodComponent"> Add/Edit Delivery Methods.
                                </a>
                            </p> 
                        </div> : `` }
                        {
                            contentType.map((channel, i) => (
                                <Category
                                    key={i}
                                    header={channel}
                                    items={contents[i]}
                                    exisitngValues={this.props.contactPreferences}
                                    removeContactPreferences={(value, id) =>
                                        this.props.removeContactPreferences(this.pageName, value, id)
                                    }
                                    addContactPreferences={(value, id) =>
                                        this.props.addContactPreferences(this.pageName, value, id)
                                    }
                                />
                            ))
                        }
                        <LinkButton
                            text="Add / Edit Delivery Methods"
                            href="#/alertPreferences/addOrEditMethodComponent"
                        />
                    </div>
                </>
            );
        }
        else {
            return <LoadingMask ctrlCss="fullpage" />;
        }
    }
}

export default compose(
    withRouter
)(BankingAlertsPage);






